module.exports = require("./zgh.js");